<template>
    <div class="new-detail">
        <div class="new-detail-swipe">
            <van-swipe class="my-swipe" :autoplay="3000" indicator-color="red">
                <van-swipe-item v-for="(item,i) in bannerList" :key="i">
                    <a href="#">
                        <img :src="item" alt="">
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="new-detail-content">
            <div class="new-detail-content-wrap">
                <div class="new-detail-content-title">{{ detail.title }}</div>
                <div class="new-detail-content-desc">
                    {{ detail.desc }}
                </div>
            </div>
            <div class="new-detail-content-box">
                <div class="new-detail-content-box-title1">
                    <div class="new-detail-content-box-title1-wrap">
                        <span :class="[flag == 0 ? 'active': '']" @click="switchTag(0)">项目介绍</span>
                        <span :class="[flag == 1 ? 'active': '']"  @click="switchTag(1)">项目进展</span>
                    </div>
                </div>
                <div class="new-detail-content-box-text" ref="content">
                    <div v-html="detail.content"></div>
                </div>
                <div class="new-detail-content-box-text" ref="progress" v-if="detail.progress != ''">
                    <van-divider />
                    <div class="progress disabled" style="margin-top: 30px">项目进展</div>
                    <div v-html="detail.progress"></div>
                </div>
            </div>
        </div>
        <div class="new-detail-news" v-if="newsList.length > 0">
            <div class="new-detail-news-title">
                大家都在看
            </div>
            <div v-for="(item,index) in newsList" :key="index">

                <div v-if="item.content_type === 2" class="article-list-section" style="padding-bottom: 0">
                    <van-row class="article-list-section-box" @click="go_article_detail(item)">
                        <van-col span="8">
                            <van-image
                                fit="cover"
                                class="article-list-content-img"
                                :src="item.cover_img"
                                width="100%"
                                height="74"
                            />
                            <div class="article-list-section-left-zl" v-if="item.type == 2">
                                图文专题
                            </div>
                        </van-col>
                        <van-col span="16" class="article-list-content">
                            <div class="article-list-title">{{item.title}}</div>
                            <div class="article-list-content-detail">
                                <div v-if="item.type != 2">{{item.created_at}}<span style="margin-left: 8px">{{item.view_count}}人阅读</span></div>
                                <div v-else>已更新{{item.current_count}}节 | 共{{item.total_count}}节 </div>
                            </div>
                        </van-col>
                    </van-row>
                </div>

                <div class="live-list-section" v-if="item.content_type === 4" style="padding-bottom: 0">
                    <van-row @click="go_live_detail(item)">
                        <div class="live-list-section-box" style="padding-bottom: 0">
                            <div class="live-list-section-left">
                                <img class="live-list-section-left-img" :src="item.cover_img">
                                <div v-if="item.type==2" class="live-list-section-left-zl">直播专题</div>
                                <div v-else-if="item.live_status==0" class="live-list-section-left-zl">直播预告</div>
                                <div v-else-if="item.live_status==1" class="live-list-section-left-zl">
                                    <img src="/static/bytx/activity_list_live_icon.gif" alt=""> 直播中
                                </div>
                                <div v-else class="live-list-section-left-zl">
                                    直播回放
                                </div>
                                <div class="live-list-section-left-time" v-if="item.live_status>1"><span>{{item.duration_format}}</span></div>
                            </div>
                            <div class="live-list-section-right">
                                <div class="live-list-section-right-title" v-html="item.title"></div>
                                <div class="live-list-section-right-detail" style="bottom: 0">
                                    <span v-if="item.type === 2">共{{item.total_count}}期</span>
                                    <span v-else-if="item.live_status < 2">{{item.start_at}}</span>
                                    <span v-else>{{item.view_count}}人观看</span>
                                    <span class="live-list-section-right-detail-join" v-if="item.type !== 2 && item.live_status < 2">
                                        <span>{{item.live_status === 0 ? item.isAppointment ? '已预约':'预约' : '加入'}}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </van-row>
                </div>
            </div>
        </div>

        <img @click="goWechat()" class="course-detail-share-button" src="/static/bytx/detail_contact_btn.svg" alt="">

        <div class="pre-page">
            <img src="/static/bytx/public/welfare_back_btn.svg" @click="$router.push({name:'medical-assistance'})">
        </div>
        <div class="new-detail-bot">
            <div class="new-detail-bot-left">
                <span @click="go">捐赠通道</span>
            </div>
            <div class="new-detail-bot-right" @click="applyHelp('')">
                <img src="/static/bytx/public/welfare_help_icon_1.svg" alt="">
                <span v-if="!detail.isApply">申请救助</span>
                <span v-else>已申请</span>
            </div>
        </div>
        <van-dialog class="apply_form" v-model="applyFormDialog" :showConfirmButton="false">
            <template slot="title">
                <div class="close-pop" @click="closeApplyForm">
                    <img src="/static/bytx/popup_close_icon.svg" alt="">
                </div>
                <h3 v-if="!detail.isApply">申请公益救助</h3>
                <h3 v-else>您已申请，无需重复提交！</h3>
            </template>
            <div class="clear"></div>
            <div v-if="!detail.isApply">为核实申请信息，为您申请公益救助项目，需您完善真实信息。</div>
            <div v-else style="text-align: center">请将项目名发给小助手，获取报名表或链接</div>
            <div v-if="!detail.isApply" align="center" style="margin-top: 12px;color: #9D9D9D">
                <van-button class="clinic-detail-footer-right-btn" type="danger" round size="large" @click="goLogin()" color="#0FB7AD">
                    立即填写
                </van-button>
            </div>
            <div v-else style="text-align: center">
                <img width="220" src="/static/qrcode/gyjz.png" alt="">
                <div>长按识别添加</div>
            </div>
        </van-dialog>

        <van-dialog class="feedback" v-model="openFeedback" :showConfirmButton="false">

            <template slot="title">
                <div class="close-pop" @click="openFeedback = false">
                    <img src="/static/bytx/popup_close_icon.svg" alt="">
                </div>
                <h3>联系小助手</h3>
            </template>

            <div class="clear"></div>

            <div>战友您好，请您长按识别下方二维码添加小助手，博医同行将因您变得更好。</div>

            <div align="center" style="margin-top: 10px">
                <img src="/static/bytx/qrcode/gyjz_v2.jpeg" alt="">
            </div>

        </van-dialog>
    </div>
</template>

<script>
import Interface from "../../../util/interface";
import checkLogin from "../../../mixins/checkLogin";
import {LocationHref} from '@/util/common'

export default {
    name: "index",
    mixins: [checkLogin],
    data() {
        return {
            id: 0,
            contentTag: '',
            applyFormDialog:false,
            openFeedback:false,
            detail:{},
            formData: {
                name:"",
                mobile:"",
                sex:"男",
                identity_name:"患者本人",
                identity:1,
            },
            newsList: [],  // 大家都在看
            bannerList: [],
            flag: 0
        }
    },
    created() {
        this.id = this.$route.params.id
        // Interface.footPrint(29,this.id,0,"浏览公益项目详情")
        this.init()
    },
    methods: {
        init() {
            Interface.getData('get',Interface.community.detail+this.id).then((res) => {
                if(res.code == 0) {
                    this.detail = res.data
                    res.data.related ? this.newsList = res.data.related : this.newsList = []
                    res.data.detail_images ? this.bannerList = res.data.detail_images : this.bannerList = [res.data.cover_img]

                    Interface.getShareInfo(this,this.detail.title,this.detail.wechat_logo,this.detail.wechat_desc)
                }
            })
        },
        // 跳转到捐赠通道
        go() {
            LocationHref(Interface.url.donation_channel_url)
            Interface.footPrint(33,0,0,"点击救助项目模块中捐赠通道")
        },
        checkPhone(tel){
            return /^1[3456789]\d{9}$/.test(tel);
        },
        // 申请救助
        apply(){
            if(!this.checkPhone(this.formData.mobile)){
                this.$toast.fail("手机号格式不正确")
                return
            }
            switch (this.formData.identity_name){
                case "患者本人":
                    this.formData.identity=1;
                    break;
                case "患者家属":
                    this.formData.identity=2;
                    break;
                case "医务工作者":
                    this.formData.identity=3;
                    break;
                default:
                    this.formData.identity=4;
                    break;
            }


            let params = {
                ...this.formData
            }
            Interface.getData('get', Interface.user.apply_community+this.id,params).then((res) => {
                if(res.code == 0){
                    this.openFeedback = true
                    this.applyFormDialog = false
                }
            })
            Interface.footPrint(31,0,0,"完成救助申请")
        },
        goLogin(){
            //申请
            let user = localStorage.getItem("user");
            user = JSON.parse(user)
            sessionStorage.setItem("back-url", this.$route.path)
            sessionStorage.setItem("apply",JSON.stringify({
                apply:'community',apply_id:this.id
            }))
            this.goAddInfo(user)
        },
        // 关闭申请救助弹框
        closeApplyForm(){
            this.applyFormDialog = false
        },
        // 大家都在看点击跳转
        go_detail(item){
            if(item.type == 1){
                this.$router.push({
                    name : 'community-detail',
                    params : {
                        id : item.id
                    }
                })
            }else{
                this.$router.push({
                    name : 'community-detail-new',
                    params : {
                        id : item.id
                    }
                })
            }
        },
        // 返回上一页
        back() {
            this.$router.go(-1)
        },
        changeIdentity(){
            this.$forceUpdate()
        },
        // 标题切换
        switchTag(num) {
            if(num == 1 && this.detail.progress != ""){
                this.$nextTick(()=>{
                    if(num == 0){
                        this.$refs.content.scrollIntoView({top: -30, left: 0, behavior: 'smooth'})
                    }else{
                        this.$refs.progress.scrollIntoView({top: -30, left: 0, behavior: 'smooth'})
                    }
                    this.flag = num
                })
            }else if(num == 1){
                this.$toast.success("点击联系我们获取最新进展~")
            }else if (num == 0){
                this.flag = num
            }
        },
        // 点击申请救助
        applyHelp(item) {
            if(!item.isApply){
                this.applyFormDialog = true
            }
            if (item && item.id) {
                Interface.footPrint(30,item.id,0,"点击救助项目模块中申请救助")
            } else {
                Interface.footPrint(30,0,0,"点击救助项目模块中申请救助")
            }
        },

        go_live_detail(item) {
            Interface.goLive(this,item.content_id,item.type,item.live_status)
        },
        go_video_detail(item){
            if (item.content_type === 2) {
                this.$router.push({'name': 'video-column', params: {id: item.id}})
            } else {
                this.$router.push({'name': 'video-detail', params: {id: item.id}})
            }
        },
        go_article_detail(item){
            if (item.type === 2) {
                this.$router.push({'name': 'article-column', params: {id: item.content_id}})
            } else {
                this.$router.push({'name': 'article-detail', params: {id: item.content_id}})
            }
        },
        goWechat(){
            LocationHref("https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8")
            Interface.footPrint(34,0,0,"点击联系客服")
        },
    }
}
</script>

<style lang="scss">
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/community/new-detail/index.vue